<template>
<div class="chapter">
<div class="inner_page">
<section>
<h2><span class="h2-inner">Prologue</span></h2>
<h3><span class="h3-inner">London, 1938</span></h3>
<p class="firstInSection">The head of SIS, the Secret Intelligence Service, had been given a brief by the Foreign Office. This he passed on for action to a major seconded to SIS from the army.</p>
<p>The brief was this: to create a new arm of SIS – a specialist section to look into how an enemy might be attacked by unusual means from within its own territory.</p>
<p>On the face of it, it was a straightforward enough assignment. Irregular warfare was nothing new. T. E. Lawrence had already used it against the Turks, and the Boers had used unmilitary tactics against the British in South Africa. The major considered the possibilities: sabotage; inciting labour unrest; use of propaganda; misleading intelligence; use of double agents; women employed as spies and couriers; anything at all that could weaken an enemy. With such breadth and complexity of the work ahead, he felt he might just as well have been given a pin and told to move the pyramids.</p>
<p>Who might be most useful and reliable against a fascist enemy – for it would be fascist? Jews would be; Marxists and Communists; leftist unions; socialists generally; and anarchists, as well as the cleverer sons and daughters of the army and navy.</p>
<p>Who had the creative imagination? Writers of popular fiction; artists; inventors; men who had created business empires from nothing.</p>
<p>Who had the skills to carry out wild schemes? Actors and actresses; people with criminal records for theft or burglary; those with mental agility gained from practising acrostics and logistical puzzles; prostitutes and gigolos; fire raisers and explosives experts; known killers who had escaped the rope with the help of silver-tongued barristers – even the barristers themselves. There were many with skills and knowledge that might be used to subvert the enemy, the Third Reich.</p>
<p>And so The Bureau was formed.</p>
<p>No square-bashing, no big guns; the shiv, the garrotte, hand-guns with silencers would be the preferred weapons of these underground, anonymous recruits.</p>
<p>No Colonel Blimp or Old Bill of the Better Hole.</p>
<p>No notion of rules of engagement.</p>
<p>No notion of fair play.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?02a5cd0d